import React from 'react'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/sv'

import { DateCalendar as MUIDateCalendar } from '@mui/x-date-pickers/DateCalendar'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useTranslation } from 'language/translator'

export interface DateCalendarProps {
  className?: string
  maxDate?: dayjs.Dayjs | string
  minDate?: dayjs.Dayjs | string
  onChange?: (value: string | null) => void
  onMonthChange?: (value: string | null) => void
  onYearChange?: (value: string | null) => void
  views?: ('day' | 'month' | 'year')[]
  value: dayjs.Dayjs | string | null
}

const DateCalendar = React.forwardRef((props: DateCalendarProps, ref: any) => {
  const {
    maxDate,
    minDate,
    onChange,
    onMonthChange,
    onYearChange,
    value,
    ...rest
  } = props

  const { lang } = useTranslation()

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lang}>
      <MUIDateCalendar
        {...rest}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        minDate={minDate ? dayjs(minDate) : undefined}
        onChange={
          onChange
            ? (value: Dayjs | null) =>
                onChange(value?.format('YYYY-MM-DD') ?? null)
            : undefined
        }
        onMonthChange={
          onMonthChange
            ? (value: Dayjs | null) =>
                onMonthChange(value?.format('YYYY-MM-DD') ?? null)
            : undefined
        }
        onYearChange={
          onYearChange
            ? (value: Dayjs | null) =>
                onYearChange(value?.format('YYYY-MM-DD') ?? null)
            : undefined
        }
        ref={ref}
        value={value ? dayjs(value) : null}
      />
    </LocalizationProvider>
  )
})

DateCalendar.displayName = 'DateCalendar'
export default DateCalendar
